import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MinorAilments from "./minor-ailment/MinorAilments";
import MedicationReview from "./medication-review/MedicationReview";
import {
  fetchClinicalService,
  fetchMedicationReview,
  setClinicalServiceName,
} from "../../../../redux/modules/clinical-services/actions";
import { ClinicalServiceTypes } from "../../text/data";
import { useLocation } from 'react-router-dom';
import { fetchNotepad } from "../../../../redux/modules/patient/actions";
import { setDefaultMedicationsFilters } from "../../../../redux/modules/medications/actions";

const LoadService = ({}) => {
  const { id:patientId, serviceId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { clinicalServiceObj, clinicalServicesSmall, clinicalServiceName } = useSelector(
    (state) => state.clinicalService
  );
  const [serviceTypeCode, setServiceTypeCode] = useState(null);

  useEffect(() => {
    const serviceTypeCode = findCodeById(serviceId);
    setServiceTypeCode(serviceTypeCode);
    dispatch(setClinicalServiceName(serviceTypeCode));
    if (serviceTypeCode === ClinicalServiceTypes.AllergicRhinitis)
      dispatch(fetchClinicalService(serviceId));
    else if (serviceTypeCode === ClinicalServiceTypes.MedicationReview)
      dispatch(fetchMedicationReview(serviceId));

    dispatch(fetchNotepad(patientId));
    dispatch(setDefaultMedicationsFilters());
  }, [patientId, serviceId,clinicalServiceName, clinicalServicesSmall]);

  if (clinicalServiceObj === null) return null;

  function findCodeById(id) {
    if (clinicalServicesSmall !== null || clinicalServicesSmall !== undefined) {
      // Search in minorAilments array
      if (clinicalServicesSmall.minorAilments)
        for (const minorAilment of clinicalServicesSmall.minorAilments) {
          if (minorAilment.id === id) {
            return minorAilment.minorAilmentTypeCode;
          }
        }
      // Search in medicationReviews array
      if (clinicalServicesSmall.medicationReviews)
        for (const medicationReview of clinicalServicesSmall.medicationReviews) {
          if (medicationReview.id === id) {
            return medicationReview.medicationReviewTypeCode;
          }
        }
    }
    return null; // Return null if the id is not found in either array
  }

  const renderStep = () => {
    switch (serviceTypeCode) {
      case ClinicalServiceTypes.AllergicRhinitis:
        return <MinorAilments />;
      case ClinicalServiceTypes.MedicationReview:
        return <MedicationReview />;
      default:
        break;
    }
  };

  return (
    <div className="bg-gray-20 flex flex-1 w-full">
      <div className="relative flex flex-col w-full gap-4 pt-[20px] bg-white">
        <div className="flex flex-col">
          <div className="flex flex-col gap-5">{renderStep()}</div>
        </div>
      </div>
    </div>
  );
};

export default LoadService;
